import { combineReducers } from 'redux'

import { connectRouter } from 'connected-react-router'

import accounting from './accounting'
import currentUser from './currentUser'
import drafts from './drafts/draftsSlice'
import emailVerification from './emailVerification'
import integrationLinkage from './integrationLinkage'
import map from './map'
import orderInfo from './orderInfo/orderInfoSlice'
import orders from './orders'
import outOfOffice from './outOfOffice/outOfOfficeSlice'
import paymentMethod from './paymentMethod/paymentMethodSlice'
import registration from './registration'
import resetPassword from './resetPassword'
import shellUser from './shellUser'
import shellUserV2 from './shellUser/shellUserSlice'
import taxProfiles from './taxProfiles/taxProfilesSlice'

const createRootReducer = history => combineReducers({
  accounting,
  currentUser,
  drafts,
  emailVerification,
  integrationLinkage,
  map,
  orderInfo,
  orders,
  outOfOffice,
  paymentMethod,
  registration,
  resetPassword,
  router: connectRouter(history),
  shellUser,
  shellUserV2,
  taxProfiles,
})

export default createRootReducer
